"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var parseError = function parseError(message) {
	throw Error("Parse error: " + message);
};
exports.default = parseError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lean-he/lib/utils/parse-error.js
// module id = 1567
// module chunks = 0